import {createAction} from 'redux-actions'

const action = baseName => createAction(`FACTOR_DETAILS_MODAL_${baseName}`)

export const show = action('SHOW')
export const hide = action('HIDE')
